import { get } from '@/helpers/http';
import { OperationEntity } from '@/types/Operation';

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    const adapert = require('../mocks/index').default;

    const fnc = require('../mocks/operations').default;
    fnc(adapert);
  })();
}

export default class OperationRepository {
  public get(id: string): Promise<OperationEntity> {
    return get(`/operation/${id}`);
  }
}
